import React, { useState } from "react";
import { Switch } from "antd";
import ModulesActions from "modules/entity/actions";
import get from "lodash/get";

import { useDispatch } from "react-redux";
import { Table } from "components";
import useTranslation from "hooks/useTranslation";
import useAlert from 'hooks/useAlert';
import { helpers } from "../../../services";
import { Fields } from "../../../uicomponents";

const CurrencySettingsModal = ({ currencyInfo, mergedRates, setCanUpdate }) => {
	const { tr } = useTranslation();
	const dispatch = useDispatch();
	const { showAlert } = useAlert();
	const [currencyValue, setCurrencyValue] = useState();


	const changeCurrencyHandler = (id, rate) => {
		dispatch(
			ModulesActions.FormDefault.request({
				method: "put",
				url: `/currency-rates/${id}`,
				values: {
					source: rate ? "custom" : "bank",
					rate: rate ? helpers.checkNumber(rate) : null
				},
				cb: {
					success: () => {
						showAlert(tr("Успешно!"), {
							type: "success",
							delay: 2000,
						});
						setCanUpdate(prev => !prev);
					},
					error: (error) => {
						const errorMessage = get(error, "errorMessage", tr("Что то пошло не так!"));
						showAlert(errorMessage, { type: "danger", delay: 5000 });
					},
					finally: () => { }
				}
			})
		);
	};

	return (
		<div>
			<div className="modal-title">{tr("Настройки валюты")}</div>
			<div className="modal-body with-hover with-bg">
				<Table
					items={mergedRates}
					isFetched={true}
					rowKey="id"
					columns={[
						{
							title: tr("Доп. валюта"),
							dataIndex: "Ccy",
							className: "w-100",
							render: value => (
								<div className="divider-wrapper">1 {value}</div>
							)
						},
						{
							title: tr("Осн. валюта"),
							dataIndex: "local",
							className: "w-[120px]",
							render: (value, row) => (
								<div className="divider-wrapper">
									{get(row, "local.source") === "custom" ? <Fields.InputS1Default
										size="small"
										placeholder={tr("Введите валюту")}
										value={get(currencyValue, "id") === get(value, "id") ? get(currencyValue, "value") : get(value, "rate")}
										className="w-full m-0 p-0"
										onChange={(e) =>
											setCurrencyValue({ id: get(value, "id"), value: e.target.value })
										}
										// onPressEnter={(e) =>
										// 	changeCurrencyHandler(get(value, "id"), get(currencyValue, "value"))
										// }
										onKeyDown={(e) => {
											if (e.key === "Enter") {
												changeCurrencyHandler(get(value, "id"), get(currencyValue, "value"));
											}
										}}
										prependData={
											<div className='form-field__prepend cursor-pointer'>UZS</div>
										}
									/> : helpers.formatNumber(get(row, "local.rate")) + " UZS"}
								</div>
							)
						},
						{
							title: tr("Последнее обновление"),
							dataIndex: "local",
							className: "w-[200px]",
							render: value => (
								<div className="divider-wrapper">{helpers.formatDateISO8601(get(value, "updated_at", "-"), "dd.mm.yyyy HH:MM")}</div>
							)
						},
						{
							title: tr("Синхронизировать с ЦБ"),
							className: "w-[150px]",
							render: (_, row) => (
								<div className="divider-wrapper flex items-center justify-center">
									<Switch
										checked={get(row, "local.source") === "bank"}
										onChange={() =>
											get(row, "local.source") === "bank" ? (changeCurrencyHandler(get(row, "local.id"), get(row, "Rate")), setCurrencyValue(get(row, "Rate"))) : changeCurrencyHandler(get(row, "local.id"))
										}
									/>
								</div>
							)
						},
						{
							title: tr("Курс по ЦБ"),
							dataIndex: "Rate",
							className: "w-[150px]",
							render: value => (
								<div className="divider-wrapper">{helpers.formatNumber(value)} UZS</div>
							)
						},
					]}
				/>
			</div>
		</div>
	);
};

export default CurrencySettingsModal;
